// extracted by mini-css-extract-plugin
export default {"container":"MainScreen_container__mK21c","bgItems":"MainScreen_bgItems__Dr6kR","inner":"MainScreen_inner__cDd72","text":"MainScreen_text__bvyyY","cards":"MainScreen_cards__HACGt"};